import type { CSSProperties, ReactNode } from "react";
import { Button, Disclosure, type DisclosureProps, DisclosurePanel, Heading } from "react-aria-components";
import { FaChevronDown } from "react-icons/fa6";
import { css } from "../../../../styled-system/css";

interface Props extends DisclosureProps {
  title: ReactNode;
  children?: ReactNode;
  marginTop?: CSSProperties["marginTop"];
}

export function Accordion({ title, children, marginTop = "3rem", ...disclosureProps }: Props) {
  return (
    <Disclosure {...disclosureProps} style={{ marginTop }}>
      <Heading
        className={css({
          margin: 0,
        })}
      >
        <Button
          slot="trigger"
          className={css({
            display: "flex",
            alignItems: "center",
            width: "100%",
            cursor: "pointer",
            background: "none",
            border: "none",
            padding: 0,
            color: "text.heading",
            fontSize: "medium",
            fontWeight: "600",
            textTransform: "uppercase",
          })}
        >
          {title}
          <FaChevronDown
            className={css({
              marginLeft: "0.5rem",
              marginRight: "0.5rem",
              fontSize: "0.75rem",
              transition: "rotate 0.3s ease-in-out",
              "[data-expanded] &": {
                rotate: "180deg",
              },
            })}
          />
          <div
            className={css({
              flexGrow: 1,
              height: "1px",
              backgroundColor: "lightgrey",
            })}
          />
        </Button>
      </Heading>
      <DisclosurePanel
        className={css({
          height: "var(--disclosure-panel-height)",
          transition: "height 0.3s ease-in-out",
          overflow: "clip",
          paddingTop: "medium",
        })}
      >
        {children}
      </DisclosurePanel>
    </Disclosure>
  );
}
